import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-round-select',
    imports: [
        CommonModule
    ],
    templateUrl: './round-select.component.html',
    styleUrl: './round-select.component.scss'
})
export class RoundSelectComponent {
    @Input('label') label: string = ''
    @Input('color') color: string = ''
    @Input('active') active: boolean = false
}
